import { render } from "./sim-status.vue?vue&type=template&id=3d3f6cea&scoped=true"
import script from "./sim-status.vue?vue&type=script&lang=js"
export * from "./sim-status.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3d3f6cea"

export default script